/* global window, document */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Money formatting (mirrors Shopify's money_format placeholders)
     --------------------------------------------------------------- */

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number === null) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    var value = '';
    var match = /\{\{\s*(\w+)\s*\}\}/.exec(format || '');
    var placeholder = match ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------------------------------------------------------------
     Bundle
     --------------------------------------------------------------- */

  function BundleDeal(root) {
    this.root = root;
    this.moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    this.totalLimit = parseInt(root.dataset.totalLimit, 10) || 0;
    this.discountCode = (root.dataset.discountCode || '').trim();

    var action = root.dataset.cartAction;
    this.cartAction = action === 'checkout' || action === 'cart' ? action : 'drawer';

    var fixedPrice = parseInt(root.dataset.bundlePrice, 10);
    this.fixedPrice = isNaN(fixedPrice) || fixedPrice <= 0 ? null : fixedPrice;

    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-tab]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-panel]'));
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));

    this.slotsEl = root.querySelector('[data-bundle-slots]');
    this.countEl = root.querySelector('[data-bundle-selected-count]');
    this.totalEl = root.querySelector('[data-bundle-total]');
    this.totalCompareEl = root.querySelector('[data-bundle-total-compare]');
    this.ctaEl = root.querySelector('[data-bundle-cta]');
    this.ctaLabelEl = root.querySelector('[data-bundle-cta-label]');
    this.ctaDefaultLabel = this.ctaLabelEl ? this.ctaLabelEl.textContent : 'Buy bundle';

    // One entry per panel: { limit, picks: [cardEl, ...] } — picks are ordered
    // oldest-first so a full group can evict its oldest selection.
    this.groups = this.panels.map(function (panel) {
      return {
        limit: parseInt(panel.dataset.bundleLimit, 10) || 1,
        picks: []
      };
    });

    this.bind();
    this.render();
  }

  BundleDeal.prototype.bind = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self.activateTab(parseInt(tab.dataset.bundleTab, 10));
      });
    });

    this.cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-bundle-add]');
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          self.toggle(card);
        });
      }

      var select = card.querySelector('[data-bundle-variant-select]');
      if (select) {
        select.addEventListener('change', function () {
          self.applyVariant(card, select.value);
        });
      }
    });

    if (this.ctaEl) {
      this.ctaEl.addEventListener('click', function () {
        self.submit();
      });
    }
  };

  /* --- tabs ------------------------------------------------------ */

  BundleDeal.prototype.activateTab = function (index) {
    this.tabs.forEach(function (tab) {
      var isActive = parseInt(tab.dataset.bundleTab, 10) === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach(function (panel) {
      var isActive = parseInt(panel.dataset.bundlePanel, 10) === index;
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  };

  /* --- variants -------------------------------------------------- */

  BundleDeal.prototype.variantsFor = function (card) {
    if (card._bundleVariants) return card._bundleVariants;

    var script = card.querySelector('[data-bundle-variants]');
    var parsed = [];

    if (script) {
      try {
        parsed = JSON.parse(script.textContent) || [];
      } catch (error) {
        parsed = [];
      }
    }

    card._bundleVariants = parsed;
    return parsed;
  };

  BundleDeal.prototype.applyVariant = function (card, variantId) {
    var variant = this.variantsFor(card).filter(function (item) {
      return String(item.id) === String(variantId);
    })[0];

    if (!variant) return;

    card.dataset.variantId = variant.id;
    card.dataset.price = variant.price;
    card.dataset.comparePrice = variant.compare_at_price || 0;
    card.dataset.variantTitle = variant.title;
    if (variant.image) card.dataset.image = variant.image;

    var priceEl = card.querySelector('[data-bundle-price]');
    var compareEl = card.querySelector('[data-bundle-compare-price]');
    var savingsEl = card.querySelector('[data-bundle-savings]');

    if (priceEl) priceEl.textContent = formatMoney(variant.price, this.moneyFormat);

    var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (compareEl) {
      if (hasCompare) {
        compareEl.textContent = formatMoney(variant.compare_at_price, this.moneyFormat);
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.setAttribute('hidden', '');
      }
    }

    if (savingsEl) {
      if (hasCompare) {
        var percent = Math.round(
          ((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price
        );
        savingsEl.textContent = '-' + percent + '%';
        savingsEl.parentElement.removeAttribute('hidden');
      } else {
        savingsEl.parentElement.setAttribute('hidden', '');
      }
    }

    var image = card.querySelector('[data-bundle-card-image]');
    if (image && variant.image) {
      image.removeAttribute('srcset');
      image.src = variant.image;
    }

    this.render();
  };

  /* --- selection ------------------------------------------------- */

  BundleDeal.prototype.groupOf = function (card) {
    return this.groups[parseInt(card.dataset.group, 10)] || null;
  };

  BundleDeal.prototype.toggle = function (card) {
    var group = this.groupOf(card);
    if (!group) return;

    var position = group.picks.indexOf(card);

    if (position !== -1) {
      group.picks.splice(position, 1);
      this.render();
      return;
    }

    // Full group: drop the oldest pick so the newest choice always lands.
    if (group.picks.length >= group.limit) {
      group.picks.shift();
    }

    group.picks.push(card);
    this.render();
    this.maybeAdvanceTab(parseInt(card.dataset.group, 10));
  };

  BundleDeal.prototype.remove = function (card) {
    var group = this.groupOf(card);
    if (!group) return;

    var position = group.picks.indexOf(card);
    if (position !== -1) {
      group.picks.splice(position, 1);
      this.render();
    }
  };

  BundleDeal.prototype.maybeAdvanceTab = function (currentIndex) {
    if (this.groups.length < 2) return;

    var current = this.groups[currentIndex];
    if (!current || current.picks.length < current.limit) return;

    for (var i = 0; i < this.groups.length; i++) {
      if (i !== currentIndex && this.groups[i].picks.length < this.groups[i].limit) {
        this.activateTab(i);
        return;
      }
    }
  };

  BundleDeal.prototype.selections = function () {
    return this.groups.reduce(function (all, group) {
      return all.concat(group.picks);
    }, []);
  };

  BundleDeal.prototype.isComplete = function () {
    return this.groups.every(function (group) {
      return group.picks.length === group.limit;
    });
  };

  /* --- rendering -------------------------------------------------- */

  BundleDeal.prototype.render = function () {
    var self = this;
    var selected = this.selections();

    this.cards.forEach(function (card) {
      var group = self.groupOf(card);
      var isSelected = group ? group.picks.indexOf(card) !== -1 : false;
      var label = card.querySelector('[data-bundle-add-label]');

      card.classList.toggle('is-selected', isSelected);
      if (label) label.textContent = isSelected ? 'Remove' : 'Add to bundle';
    });

    this.tabs.forEach(function (tab) {
      var index = parseInt(tab.dataset.bundleTab, 10);
      var group = self.groups[index];
      if (!group) return;

      var counter = tab.querySelector('[data-bundle-tab-count]');
      if (counter) counter.textContent = group.picks.length + '/' + group.limit;
      tab.classList.toggle('is-complete', group.picks.length === group.limit);
    });

    if (this.countEl) this.countEl.textContent = selected.length;

    this.renderSlots();
    this.renderTotal(selected);

    if (this.ctaEl) this.ctaEl.disabled = !this.isComplete();
  };

  BundleDeal.prototype.renderSlots = function () {
    if (!this.slotsEl) return;

    var self = this;
    this.slotsEl.innerHTML = '';

    var slotNumber = 0;

    this.groups.forEach(function (group) {
      for (var i = 0; i < group.limit; i++) {
        if (slotNumber > 0) {
          var separator = document.createElement('span');
          separator.className = 'bundle-deal__bar-sep';
          separator.textContent = '+';
          self.slotsEl.appendChild(separator);
        }
        slotNumber++;

        var slot = document.createElement('div');
        slot.className = 'bundle-deal__bar-slot';

        var card = group.picks[i];

        if (card) {
          slot.classList.add('bundle-deal__bar-slot--filled');

          var image = document.createElement('img');
          image.src = card.dataset.image || '';
          image.alt = card.dataset.productTitle || '';
          image.width = 56;
          image.height = 56;
          image.loading = 'lazy';

          var removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'bundle-deal__bar-remove';
          removeBtn.innerHTML = '&#10005;';
          removeBtn.setAttribute(
            'aria-label',
            'Remove ' + (card.dataset.productTitle || 'item') + ' from bundle'
          );
          removeBtn.addEventListener('click', function () {
            self.remove(card);
          });

          slot.appendChild(image);
          slot.appendChild(removeBtn);
        } else {
          var placeholder = document.createElement('span');
          placeholder.className = 'bundle-deal__bar-slot-index';
          placeholder.textContent = slotNumber;
          slot.appendChild(placeholder);
        }

        self.slotsEl.appendChild(slot);
      }
    });
  };

  BundleDeal.prototype.renderTotal = function (selected) {
    if (!this.totalEl) return;

    if (!selected.length) {
      this.totalEl.textContent = this.fixedPrice
        ? formatMoney(this.fixedPrice, this.moneyFormat)
        : '—';
      if (this.totalCompareEl) this.totalCompareEl.setAttribute('hidden', '');
      return;
    }

    var sum = 0;
    var compareSum = 0;

    selected.forEach(function (card) {
      var price = parseInt(card.dataset.price, 10) || 0;
      var compare = parseInt(card.dataset.comparePrice, 10) || 0;
      sum += price;
      compareSum += compare > price ? compare : price;
    });

    var total = this.fixedPrice !== null && this.isComplete() ? this.fixedPrice : sum;
    var strikethrough = this.fixedPrice !== null && this.isComplete() ? sum : compareSum;

    this.totalEl.textContent = formatMoney(total, this.moneyFormat);

    if (this.totalCompareEl) {
      if (strikethrough > total) {
        this.totalCompareEl.textContent = formatMoney(strikethrough, this.moneyFormat);
        this.totalCompareEl.removeAttribute('hidden');
      } else {
        this.totalCompareEl.setAttribute('hidden', '');
      }
    }
  };

  /* --- checkout --------------------------------------------------- */

  BundleDeal.prototype.rootUrl = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  BundleDeal.prototype.destination = function () {
    var base = this.cartAction === 'checkout' ? '/checkout' : '/cart';

    if (this.discountCode) {
      return '/discount/' + encodeURIComponent(this.discountCode) + '?redirect=' + encodeURIComponent(base);
    }

    return base;
  };

  // Registers the discount on the session so it survives into the drawer, which
  // never navigates through /discount/<code> the way a redirect would.
  BundleDeal.prototype.applyDiscount = function () {
    if (!this.discountCode) return Promise.resolve();

    return fetch(this.rootUrl() + 'discount/' + encodeURIComponent(this.discountCode), {
      credentials: 'same-origin'
    }).catch(function () {});
  };

  // Mirrors what the theme's own add-to-cart does so the header count and any
  // other cart listeners stay in sync. `openMiniCart` stays false — Shopflo's
  // drawer is the one we want, not the theme's.
  BundleDeal.prototype.notifyCartUpdated = function () {
    return fetch(this.rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: cart, openMiniCart: true }
          })
        );
      })
      .catch(function () {});
  };

  // Shopflo's bundle is loaded async, so it may not have booted yet. Poll
  // briefly before giving up and letting the caller fall back to a redirect.
  BundleDeal.prototype.openFloCart = function () {
    return new Promise(function (resolve) {
      // 400ms delay gives the theme time to finish updating the cart icon's HTML
      setTimeout(function () {
        // Also look for #cart-icon-bubble as a safe fallback for modern themes
        var cartLink = document.querySelector('#cart-icon-bubble') || document.querySelector('[href="/cart"]');
        if (cartLink) {
          cartLink.click();
        }
        resolve(true);
      }, 400); 
    });
  };

  BundleDeal.prototype.submit = function () {
    var self = this;
    if (!this.isComplete() || this.busy) return;

    var counts = {};

    this.selections().forEach(function (card) {
      var id = card.dataset.variantId;
      counts[id] = (counts[id] || 0) + 1;
    });

    var items = Object.keys(counts).map(function (id) {
      return { id: id, quantity: counts[id] };
    });

    this.busy = true;
    this.ctaEl.classList.add('is-loading');
    if (this.ctaLabelEl) this.ctaLabelEl.textContent = 'Adding…';

    fetch(this.rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      })
      .then(function () {
        return self.applyDiscount();
      })
      .then(function () {
        return self.notifyCartUpdated();
      })
      .then(function () {
        if (self.cartAction !== 'drawer') {
          window.location.href = self.destination();
          return null;
        }

        return self.openFloCart().then(function (opened) {
          // Shopflo never booted — send the shopper to the cart page instead of
          // leaving the button looking like it did nothing.
          if (!opened) window.location.href = self.destination();
          return opened;
        });
      })
      .then(function (opened) {
        if (opened !== true) return;

        self.busy = false;
        self.ctaEl.classList.remove('is-loading');
        if (self.ctaLabelEl) self.ctaLabelEl.textContent = self.ctaDefaultLabel;
      })
      .catch(function () {
        self.busy = false;
        self.ctaEl.classList.remove('is-loading');
        if (self.ctaLabelEl) self.ctaLabelEl.textContent = self.ctaDefaultLabel;
        // window.alert('Sorry, we could not add this bundle to your cart. Please try again.');
      });
  };

  /* --- boot ------------------------------------------------------- */

  function init() {
    document.querySelectorAll('[data-bundle-deal]').forEach(function (root) {
      if (root._bundleDeal) return;
      root._bundleDeal = new BundleDeal(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
